import { Text } from '@eds-web/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { PrizeList } from './PrizeList';
import { device } from '../../constants/breakpoint';

const PrizeListContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media screen and ${device.laptop} {
        gap: 16px;
    }
`;

export const Prizes: React.FC = () => {
    const { t } = useTranslation();
    return (
        <PrizeListContent>
            <Text variant={'paragraphMD'} color={'secondary'}>
                {t('epic.esport.prizes.board.content')}
            </Text>
            <PrizeList />
        </PrizeListContent>
    );
};
